"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectorObjectExporter = ConnectorObjectExporter;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _ConnectorSelector = require("./ConnectorSelector");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ConnectorObjectExporter(_ref) {
  var tenantId = _ref.tenantId,
    familyId = _ref.familyId,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'DATA' : _ref$type,
    givenTitle = _ref.title,
    onExport = _ref.onExport,
    onClose = _ref.onClose,
    maxDaySelected = _ref.maxDaySelected,
    includeDefault = _ref.includeDefault;
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    connectorId = _useState2[0],
    setConnectorId = _useState2[1];
  var _useState3 = (0, _react.useState)(new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate())),
    _useState4 = _slicedToArray(_useState3, 2),
    sDate = _useState4[0],
    setSDate = _useState4[1];
  var _useState5 = (0, _react.useState)(new Date()),
    _useState6 = _slicedToArray(_useState5, 2),
    eDate = _useState6[0],
    setEDate = _useState6[1];
  var title = (0, _react.useMemo)(function () {
    if (givenTitle) {
      return givenTitle;
    }
    var key = type === 'DATA' ? 'connectors.download_data.title' : 'connectors.download_by_range.title';
    return (0, _core.translate)(key);
  }, [type, givenTitle]);
  var onChangeDateRange = function onChangeDateRange(startDate, endDate) {
    var difference = endDate.getTime() - startDate.getTime();
    var daysBetween = Math.round(difference / (1000 * 60 * 60 * 24));
    if (daysBetween && maxDaySelected && daysBetween > maxDaySelected) {
      feedbackContext.showWarning((0, _core.translate)("connectors.download_by_range.range_limit", {
        dias: maxDaySelected
      }));
    } else {
      setSDate(startDate);
      setEDate(endDate);
    }
  };
  var onClickExport = function onClickExport() {
    if ('DATA_RANGE' === type) {
      onExport(connectorId || '', sDate, eDate);
    } else {
      onExport(connectorId || '');
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    title: title,
    onClose: onClose,
    disableBackdropClick: true,
    button: {
      text: (0, _core.translate)('buttons.export'),
      onClick: onClickExport,
      disabled: connectorId === undefined
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    gutterBottom: true
  }, (0, _core.translate)('connectors.formats.choose'))), type === 'DATA_RANGE' && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sx: {
      marginBottom: 2
    }
  }, /*#__PURE__*/_react["default"].createElement(_commons.CustomDateRanges, {
    startDate: sDate,
    endDate: eDate,
    onChange: onChangeDateRange
  })), /*#__PURE__*/_react["default"].createElement(_ConnectorSelector.ConnectorSelector, {
    tenantId: tenantId,
    familyId: familyId,
    direction: "OUTPUT",
    includeDefault: includeDefault,
    onChangedConnector: setConnectorId
  })));
}